import { aboutUsNewsDetailsComponent } from './about-us-news-details.component';

import 'angular-sanitize/angular-sanitize';
import './about-us-news-details.scss';

export const aboutUsNewsDetails = angular
     .module('components.aboutUsNewsDetails', ['ngSanitize'])
     .component('aboutUsNewsDetails', aboutUsNewsDetailsComponent)
     .name;


// WEBPACK FOOTER //
// ./src/app/components/about-us-news-details/about-us-news-details.module.js